import React, { SVGProps } from 'react';

export const VideoCameraSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.5 3.50781H8.5C8.5 3.50781 10.5 3.50781 10.5 5.50781V10.5078C10.5 10.5078 10.5 12.5078 8.5 12.5078H2.5C2.5 12.5078 0.5 12.5078 0.5 10.5078V5.50781C0.5 5.50781 0.5 3.50781 2.5 3.50781Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.5 10.0073L14.7767 11.1453C14.8529 11.1834 14.9376 11.2013 15.0227 11.1975C15.1078 11.1936 15.1905 11.1681 15.263 11.1232C15.3355 11.0784 15.3953 11.0158 15.4367 10.9414C15.4782 10.867 15.5 10.7832 15.5 10.698V5.31601C15.5001 5.2308 15.4783 5.14699 15.4368 5.07255C15.3954 4.99811 15.3355 4.93553 15.263 4.89076C15.1905 4.84599 15.1078 4.82052 15.0226 4.81677C14.9375 4.81302 14.8528 4.83112 14.7767 4.86935L12.5 6.00735'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
